import { render, staticRenderFns } from "./CmgErrorModal.vue?vue&type=template&id=4fbfab21&scoped=true&lang=pug"
import script from "./cmg-error-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-error-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgErrorModal.vue?vue&type=style&index=0&id=4fbfab21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbfab21",
  null
  
)

export default component.exports